module.exports = __webpack_public_path__ + "img/footer.f9f4584b.png";